// extracted by mini-css-extract-plugin
export default {"dis":"Home_dis__VLsYr","search":"Home_search__SSkzR"};